const SHARED_MESSAGES = {
  'auth/invalid-email': 'Enter a valid email address and try again.',
  'auth/missing-email': 'Enter your email address to continue.',
  'auth/network-request-failed': 'Connection lost. Check your internet connection and try again.',
  'auth/too-many-requests': 'Too many attempts were made. Wait a moment, then try again or reset your password.',
  'auth/user-disabled': 'This account is disabled. Contact your administrator for access.',
  'auth/operation-not-allowed': 'This sign-in method is not available right now. Contact your administrator if this continues.',
  'auth/unauthorized-domain': 'This sign-in method is not available from this domain right now.',
};

const LOGIN_MESSAGES = {
  'auth/invalid-credential': 'The email or password did not match our records.',
  'auth/user-not-found': 'The email or password did not match our records.',
  'auth/wrong-password': 'The email or password did not match our records.',
};

const GOOGLE_MESSAGES = {
  'auth/popup-closed-by-user': 'Google sign-in was closed before it finished.',
  'auth/popup-blocked': 'Your browser blocked the Google sign-in window. Allow pop-ups and try again.',
  'auth/cancelled-popup-request': 'Google sign-in is already in progress. Finish the open sign-in window first.',
  'auth/account-exists-with-different-credential': 'This email is already linked to a different sign-in method. Use that method first.',
};

const RESET_MESSAGES = {
  'auth/invalid-action-code': 'This reset link is no longer valid. Request a new reset email.',
  'auth/expired-action-code': 'This reset link has expired. Request a new reset email.',
};

function getFallbackMessage(context) {
  if (context === 'google') {
    return 'Google sign-in could not be completed. Try again or use your email and password.';
  }
  if (context === 'reset') {
    return 'We could not send the reset email. Confirm the address and try again.';
  }
  return 'We could not sign you in. Check your details and try again.';
}

export function getAuthErrorMessage(error, context = 'login') {
  const code = String(error?.code || '');

  if (context === 'google' && GOOGLE_MESSAGES[code]) {
    return GOOGLE_MESSAGES[code];
  }

  if (context === 'reset' && RESET_MESSAGES[code]) {
    return RESET_MESSAGES[code];
  }

  if (LOGIN_MESSAGES[code]) {
    return LOGIN_MESSAGES[code];
  }

  if (SHARED_MESSAGES[code]) {
    return SHARED_MESSAGES[code];
  }

  return getFallbackMessage(context);
}

export function shouldTreatResetAsSent(error) {
  return String(error?.code || '') === 'auth/user-not-found';
}
